import { render, staticRenderFns } from "./AdvancedSettingsModal.vue?vue&type=template&id=35826950&scoped=true"
import script from "./AdvancedSettingsModal.vue?vue&type=script&lang=js"
export * from "./AdvancedSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./AdvancedSettingsModal.vue?vue&type=style&index=0&id=35826950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35826950",
  null
  
)

export default component.exports